import React from 'react';
import { Spinner } from 'reactstrap';
export default function Loading() {

    return (
        <div className="carregando">
            <div className="box">
                <Spinner style={{ color: "#06414B" }}></Spinner>
            </div>
        </div>
    )
}